import { apiController } from "./baseUrl";
import type { SubtaskExtrasBody } from "../utils/subtaskPayload";

export const fetch_dashboard_data = () => {
  const response = apiController.get("dashboard/dashboard_data");
  return response;
};

export const login = (body: any) => {
  console.log(body);
  const response = apiController.post("/login", body);
  return response;
};

export const tasksByUser = (query: any) => {
  const queryString = new URLSearchParams(query).toString(); // Convert query object to query string
  const response = apiController.post(`/tasks/by-user?${queryString}`); // Send GET request with query
  return response;
};

export const addTasks = (query: any) => {
  const queryString = new URLSearchParams(query).toString(); // Convert query object to query string
  const response = apiController.post(`/addtask?${queryString}`); // Send GET request with query
  return response;
};

export const logHours = (query: any) => {
  const queryString = new URLSearchParams(query).toString(); // Convert query object to query string
  const response = apiController.post(`/addcompletedlog?${queryString}`); // Send GET request with query
  return response;
};

export const updateTaskStatus = (query: any) => {
  const queryString = new URLSearchParams(query).toString();
  const response = apiController.post(`/tasks/update-status?${queryString}`);
  return response;
};

export const taskWithLogs = (query: any) => {
  const queryString = new URLSearchParams(query).toString(); // Convert query object to query string
  const response = apiController.post(
    `/tasks/with-logs/by-user?${queryString}`,
  ); // Send GET request with query
  return response;
};

export const generateReport = (query: any) => {
  const queryString = new URLSearchParams(query).toString(); // Convert query object to query string
  const response = apiController.post(
    `/report/weekly/structured?${queryString}`,
  ); // Send GET request with query
  return response;
};

export type GithubChangesReportPayload = {
  githubUrl: string;
  startDate: string;
  endDate: string;
};

export type GithubChangesByProjectPayload = {
  projectName: string;
  startDate: string;
  endDate: string;
};

/** POST JSON body: GitHub activity / changes report for a repository URL and date range. */
export const reportGithubChanges = (body: GithubChangesReportPayload) => {
  return apiController.post(`/report/github-changes`, body, {
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

/** POST JSON body: GitHub changes report scoped by project name and date range (admin). */
export const reportGithubChangesByProject = (body: GithubChangesByProjectPayload) => {
  return apiController.post(`/report/github-changes`, body, {
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const addUser = (body: any) => {
  const response = apiController.post(`/adduser`, body);
  return response;
};

export const deleteUser = (query: any) => {
  const queryString = new URLSearchParams(query).toString(); // Convert query object to query string
  const response = apiController.post(`/deleteuser?${queryString}`);
  return response;
};

export const getAllUsers = () => {
  const response = apiController.post(`/getalluser`);
  return response;
};

export const getAllUsersReport = () => {
  const response = apiController.post(`/getcompletereport`);
  return response;
};

export const reportAI = (query: any) => {
  const queryString = new URLSearchParams(query).toString(); // Convert query object to query string
  const response = apiController.post(`/report/ai?${queryString}`);
  return response;
};

export const editTask = (taskId: any, taskData: any) => {
  const queryString = new URLSearchParams(taskData).toString();
  const response = apiController.put(`/updatetask/${taskId}?${queryString}`);
  return response;
};
export const deleteTask = (taskId: any) => {
  const response = apiController.post(`/deletetask?task_id=${taskId}`);
  return response;
};
export const deleteLog = (logId: any) => {
  const response = apiController.delete(`/deletecompletedlog?logId=${logId}`);
  return response;
};
export const getAllTasks = () => {
  const response = apiController.post(`/projects`);
  return response;
};
export const getAllClientGroups = () => {
  const response = apiController.post(`/client-groups`);
  return response;
};
export const generateReportByClientGroup = (
  clientGroup: any,
  filters: { startDate?: string; endDate?: string } = {},
) => {
  const params = new URLSearchParams();
  params.append("client_group", clientGroup);
  if (filters.startDate) {
    params.append("startDate", filters.startDate);
  }
  if (filters.endDate) {
    params.append("endDate", filters.endDate);
  }
  const response = apiController.post(
    `/report/client-group?${params.toString()}`,
  );
  return response;
};

export const generateReportByTask = (
  task: any,
  filters: { startDate?: string; endDate?: string } = {},
) => {
  const params = new URLSearchParams();
  params.append("task", task);
  if (filters.startDate) {
    params.append("startDate", filters.startDate);
  }
  if (filters.endDate) {
    params.append("endDate", filters.endDate);
  }
  const response = apiController.post(`/report/task?${params.toString()}`);
  return response;
};

export const getTracking = (query: any) => {
  const response = apiController.post(`/get-tracking?filters=${query}`);
  return response;
};
export const uploadSheets = (body: any) => {
  const response = apiController.post(`/upload`, body);
  return response;
};
function subtaskQueryString(query: Record<string, unknown>): string {
  return new URLSearchParams(
    Object.fromEntries(
      Object.entries(query)
        .filter(([, v]) => v !== undefined && v !== null)
        .map(([k, v]) => [k, String(v)]),
    ),
  ).toString();
}

/** Scalar fields on query string; verificationEndpoints + commitHashes in JSON body. */
export const addSubtask = (
  query: Record<string, unknown>,
  extras?: SubtaskExtrasBody,
) => {
  const url = `/addsubtask?${subtaskQueryString(query)}`;
  if (!extras || Object.keys(extras).length === 0) {
    return apiController.post(url);
  }
  return apiController.post(url, extras, {
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

// export const getSubTasks=(userId:any)=>{
//     const response=apiController.post(`/subtasks/by-user`)
//     return response
// }
export const getSubTasksByUser = (query: any) => {
  const queryString = new URLSearchParams(query).toString(); // Convert query object to query string
  const response = apiController.post(`/subtasks/by-user?${queryString}`); // Send GET request with query
  return response;
};

export const addSubtaskLog = (body: any) => {
  // const response=apiController.post(`/addsubtasklog`, body)
  // return response
  const queryString = new URLSearchParams(body).toString(); // Convert query object to query string
  const response = apiController.post(`/addsubtasklog?${queryString}`); // Send GET request with query
  return response;
};
export const subTaskLogs = (userId: any) => {
  const queryString = new URLSearchParams(userId).toString();
  const response = apiController.post(`/subtasklogs/by-user?${queryString}`);
  return response;
};

/** Scalar fields on query string; verificationEndpoints + commitHashes in JSON body. */
export const updateSubTask = (
  query: Record<string, unknown>,
  extras?: SubtaskExtrasBody,
) => {
  const url = `/updatesubtask?${subtaskQueryString(query)}`;
  if (!extras || Object.keys(extras).length === 0) {
    return apiController.post(url);
  }
  return apiController.post(url, extras, {
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const updateSubtaskBlocker = (subtaskId: number, blocker: string) => {
  const queryString = new URLSearchParams({
    subtask_id: String(subtaskId),
    blocker,
  }).toString();
  return apiController.post(`/subtask/blocker?${queryString}`);
};

export const deleteSubTask = (subTaskId: any) => {
  // const response=apiController.post(`/deletesubtask?sub_task_id=${subTaskId}`)
  // return response

  const response = apiController.post(`/deletesubtask?subtask_id=${subTaskId}`);
  return response;
};

export const deleteSubTaskLog = (logId: any) => {
  const response = apiController.post(`/deletesubtasklog?log_id=${logId}`);
  return response;
};

export const editTasklog = (logData: any) => {
  const queryString = new URLSearchParams(logData).toString();
  const response = apiController.post(`/updatecompletedlog?${queryString}`);
  return response;
};

export const generateAIDesc = (desc: any) => {
  const response = apiController.post(`/aidescriptions?desc=${desc}`);
  return response;
};

export const getDashboard = (params: any) => {
  try {
    const response = apiController.post(`/dashboard`, params, {
      headers: {
        accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    console.error("Error in getDashboard API call:", error);
    throw error;
  }
};
export const getAvailableDates = () => {
  const response = apiController.post(`/available-dates`);
  return response;
};

// Super Admin API functions
export const addAdmin = (body: any) => {
  const response = apiController.post(`/addadmin`, body);
  return response;
};

export const getAllAdmins = () => {
  const response = apiController.post(`/getalladmins`);
  return response;
};

export const deleteAdmin = (query: any) => {
  const queryString = new URLSearchParams(query).toString();
  const response = apiController.post(`/deleteadmin?${queryString}`);
  return response;
};

export const updateAdmin = (adminId: any, adminData: any) => {
  const queryString = new URLSearchParams(adminData).toString();
  const response = apiController.put(`/updateadmin/${adminId}?${queryString}`);
  return response;
};

export const getAllUsersWeeklyReport = () => {
  const response = apiController.post(`/getweeklyreport-for-every-user`);
  return response;
};
export const generateReportByTeamMemberSummary = (params = {}) => {
  const query = new URLSearchParams(params).toString();

  const response = apiController.post(
    `/report/weekly/team-member-summary?${query}`,
  );
  return response;
};
export const generateReportByOpenJobsByClientGroup = (
  params: Record<string, string | number | boolean | null | undefined> = {},
) => {
  const normalizedParams = Object.fromEntries(
    Object.entries(params)
      .filter(([, value]) => value !== undefined && value !== null)
      .map(([key, value]) => [key, String(value)]),
  );
  const query = new URLSearchParams(normalizedParams).toString();
  return apiController.post(
    `/report/weekly/open-jobs-by-client-group?${query}`,
  );
};

export const generateReportByOpenJobsByJobName = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return apiController.post(`/report/weekly/open-jobs-by-job-name?${query}`);
};

export const generateClientGroupUserHoursReport = (
  params: Record<string, string | number | boolean | null | undefined> = {},
) => {
  const normalizedParams = Object.fromEntries(
    Object.entries(params)
      .filter(([, value]) => value !== undefined && value !== null)
      .map(([key, value]) => [key, String(value)]),
  );
  const query = new URLSearchParams(normalizedParams).toString();
  return apiController.post(`/report/client-group-user-hours?${query}`);
};

export const generateReportByClientGroupActivityRanking = () => {
  const response = apiController.post(
    `/report/weekly/client-group-activity-ranking`,
  );
  return response;
};
export const generateReportByClosedJobs = (
  params: Record<string, string | number | boolean | null | undefined> = {},
) => {
  const normalizedParams = Object.fromEntries(
    Object.entries(params)
      .filter(([, value]) => value !== undefined && value !== null)
      .map(([key, value]) => [key, String(value)]),
  );
  const query = new URLSearchParams(normalizedParams).toString();
  return apiController.post(`/report/weekly/closed-jobs?${query}`);
};

// Report column config API functions

export const getReportColumnConfig = (userId: string, reportKey: string) => {
  const query = new URLSearchParams({ userId, reportKey }).toString();
  return apiController.get(`user/report-column-config?${query}`);
};

export const saveReportColumnConfig = (body: {
  userId: string;
  reportKey: string;
  columns: string[];
}) => {
  return apiController.post("user/report-column-config", body);
};

/** GET dev worklog for a user and date range (DD-MM-YYYY). */
export const getDevWorklog = (params: {
  startDate: string;
  endDate: string;
  userId?: string;
}) => {
  const query = new URLSearchParams({
    userId: params.userId ?? "daniyal",
    startDate: params.startDate,
    endDate: params.endDate,
  }).toString();
  return apiController.post(`/api/dev/worklog?${query}`);
};
